import getParsedRedirectUrl from "./getParsedRedirectUrl";

const brandEventPropertyMapper = ({
	brand,
	order = null,
	idx = -1,
	upsell = false,
	feedHasUpsell,
} = {}) => {
	if (!brand || typeof brand !== "object") return {};

	const {
		name,
		code,
		masked_url: brandUrl,
		id: brandId,
		ml_order: mlOrder,
		metadata: eventMetadata = {},
		self = false,
	} = brand;

	upsell = upsell || self;

	const redirectURL = getParsedRedirectUrl({ brand, upsell });

	const brandViewOrder =
		order !== null ? order : feedHasUpsell ? idx - 1 : idx;

	const defaultEventProps = {
		brand: name,
		brand_id: brandId,
		_brand_view_order: brandViewOrder, // Adding alias to prevent override collision & maintain data (ex: WidgetCard/ProductCard.jsx)
		brand_view_order: brandViewOrder,
		code,
		ml_order: mlOrder,
		brand_link: brandUrl,
		brand_redirect_link: redirectURL,
		...eventMetadata,
	};

	return defaultEventProps;
};

export default brandEventPropertyMapper;
